import './live-chat';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { BcLiveChatModule } from './live-chat.module';
import { ServiceWorkerService } from 'shared/services/service-worker/service-worker.service';

if (!(<any>window).isUnitTest) {
  enableProdMode();

  if ('serviceWorker' in navigator) {
    const boldURLPattern = /([a-zA-Z0-9-_]+\.)(bold360)\.(com|io)/i;
    const { protocol, host, hostname, pathname } = window.location;

    let path = pathname.endsWith('/') ? pathname.substr(0, pathname.length - 1) : pathname;

    if (boldURLPattern.test(hostname)) {
      path = '';
    }

    const serviceWorkerBaseUrl = `${protocol}//${host}${path}/service-worker.js`;
    navigator.serviceWorker.register(serviceWorkerBaseUrl).then(registration => {
      ServiceWorkerService.setRegistration(registration);
    });
  }

  platformBrowserDynamic().bootstrapModule(BcLiveChatModule, []);
}
